import BasicText from "@/components/BasicText";
import Subtitle from "@/components/Subtitle";
import Title from "@/components/Title";
import Image from "@/components/Image";

import glassEffect from "@/assets/images/what-is-node-glass-effect.svg";
import star from "@/assets/images/what-is-node-star.svg";
import ellipseLarge from "@/assets/images/what-is-node-2.png";
import ellipseSmall from "@/assets/images/what-is-node-1.png";

const WhatIsNode: React.FC = () => {
  return (
    <div className="flex flex-col p-20 pb-0 md:pb-20 z-30 relative">
      <Subtitle>// $NODE</Subtitle>
      <Title className="mt-2 max-w-[70%]">
        Node is the driving force behind Luminode's ecosystem.&nbsp;
        <span className="text-faded">Lorem ipsum
          dolor sit consectetur.</span>
      </Title>

      <BasicText className="mt-4 max-w-[70%]" size="18px" color="faded">
        Designed to fuel our decentralized infrastructure. Whether you’re a
        developer or a user, $NODE opens the door to limitless possibilities.
      </BasicText>

      <div className="hidden md:block relative w-full h-[546px] mx-10 md:mt-16 self-center rounded-lg overflow-hidden">
        <div
          className="relative w-full h-full shadow-inner-glow"
          style={{
            background:
              "radial-gradient(49.42% 28.47% at 50% -4.24%, rgba(255, 255, 255, 0.29) 0%, rgba(255, 255, 255, 0.00) 100%), linear-gradient(180deg, rgba(16, 19, 30, 0.00) 0%, rgba(16, 19, 30, 0.20) 100%), #090910;",
          }}
        >
          <Image
            className="z-0 absolute left-[250px] bottom-1 hidden lg:block"
            src={ellipseSmall}
            alt="glass effect"
          />
          <Image
            className="z-0 absolute right-0"
            src={ellipseLarge}
            alt="glass effect"
          />
          <Image className="z-30 absolute bottom-0" src={glassEffect} alt="glass effect" />
        </div>

        <BasicText className="hidden lg:block text-[14px] text-white z-0 opacity-40 m-20 absolute top-10 left-10">
          <div>{"!>@-!##!+!@-!>!!#!+"}</div>
          <div className="mx-10">{"!+<!-@@-@@!!@!@@-@!!#!"}</div>
        </BasicText>

        <BasicText className="flex flex-col opacity-50 absolute bottom-10 left-10 h-fit z-50">
          <h1>// LAUNCH INITIALIZED</h1>
          <h1>// AWAITING ADMIN PASSWORD</h1>
          <h1>// ****************</h1>
          <h1>// LAUNCH SUCCESSFUL</h1>
        </BasicText>
      </div>
    </div>
  );
};

export default WhatIsNode;
